// @flow
import 'isomorphic-fetch';
import { getAPIDomain } from 'shared/lib/clientSettings';

/**
 * Get the client's country code from CORE-API /ip2country endpoint.
 * If the country is not in the list of allowed regions, some front-end
 * functionalities/visibilities may be altered.
 */
const isIPAllowed = (regions: Array<string>) => {
  const allowedRegions = regions || ['US'];
  const fetchDomain = getAPIDomain('US') || '';

  return fetch(`${fetchDomain}/ip2country`)
    .then(r => r.json())
    .then(r => allowedRegions.includes(r.countryCode))
    .catch(e => console.log(e));
};

export default isIPAllowed;
